module.exports = __webpack_public_path__ + "static/media/customer-1.e903b56d.png";